<template>
  <div class="mytaskList">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
      <el-form-item label="任务名称">
        <el-input v-model="searchForm.task_name" clearable size="small" style="width:300px" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="会议主题">
        <el-input v-model="searchForm.meeting_subject" clearable size="small" style="width:300px" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="会议时间">
        <el-date-picker
          v-model="searchForm.meetTime"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"/>
      </el-form-item>
      <el-form-item label="任务创建时间">
        <el-date-picker
          v-model="searchForm.time"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"/>
      </el-form-item>
      <el-form-item label="会议编号">
        <el-input v-model="searchForm.meeting_id" clearable size="small"/>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" icon="el-icon-search" type="primary" @click="searchFormSubmit">查询</el-button>
      </el-form-item>
    </el-form>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="'全部 ('+status_total.all_num+')'" name="all"/>
      <el-tab-pane :label="'未完成 ('+status_total.uncompleted+')'" name="uncompleted"/>
      <el-tab-pane :label="'逾期 ('+status_total.overdue+')'" name="overdue"/>
      <el-tab-pane :label="'已完成 ('+status_total.complete+')'" name="complete"/>
    </el-tabs>
    <el-card v-for="(item,index) in taskList" :key="index" class="box-card" @click.native="openBox(item.id)">
      <div class="amTask"> <span style="cursor: pointer;"> {{ item.task_name }}</span> &nbsp;&nbsp;
        <el-tag :type="item.is_complete==1?'success':'info'" size="small" effect="dark">
          {{ item.is_complete==1?'已完成':'未完成' }}</el-tag>
        <el-tag v-show="item.is_overdue==1" type="danger" size="small" effect="dark">逾期</el-tag>

      </div>
      <div class="taskTip">
        <i class="el-icon-time time"/>
        截止时间：{{ item.planned_complete_time }}
        <span/>
        <span>
          负责人：
          <el-tag size="small" effect="plain" type="">{{ item.executor[0].name }}</el-tag>
        </span>
        <span>
          创建人：
          <el-tag size="small" effect="plain" type="info">{{ item.creator_name }}</el-tag>
        </span>
        ( 编号：{{ item.meeting_id }} ) 会议主题：<b style="cursor: pointer;" @click="goMeeting(item.meeting_id)">{{ item.meeting_subject }}</b>
      </div>
      <!-- <div> <el-button type="success" size="small" >编辑</el-button></div> -->
    </el-card>
    <el-card v-if="taskList.length==0" class="box-card" style="margin-top: 10px;">
      <div>无数据</div>
    </el-card>

    <div style="text-align: center;margin-top:20px;">
      <el-pagination
        :current-page="page"
        :page-sizes="[6, 10, 30, 50]"
        :page-size="page_size"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"/>
    </div>

    <!-- 右侧弹框 -->
    <el-drawer :visible.sync="drawer" :with-header="false" :show-close="true" :modal="false" title="我是标题" size="700px">
      <div class="drawer-content">
        <div class="drawer-top">
          <el-row class="drawer-item">
            <el-col :span="20">
              <b>{{ taskData.task_name }}</b>
            </el-col>
          <!-- <el-col :span="4">
            <el-button type="primary" size="small" v-if="taskData.is_complete=='0'" @click="enterSubmit(taskData.id)">
              确认完成</el-button>
            <el-button disabled type="success" size="small" v-else>执行完成</el-button>
          </el-col> -->
          </el-row>
          <el-row class="drawer-item">
            <el-col>
              <span><i class="el-icon-date icons"/> 计划完成时间：{{ taskData.planned_complete_time }}</span>

            </el-col>
          </el-row>
          <el-row class="drawer-item">
            <el-col>
              <!-- <span> <span> 负责人:</span>{{taskData.executor?taskData.executor[0].name:''}}</span> -->
              <span v-if="taskData.executor.length>0"><i class="el-icon-user icons"/>负责人：{{ taskData.executor.length>0?taskData.executor[0].name:'' }}</span><br>

              <span v-if="taskData.liability.length>0">
                <i class="el-icon-user icons"/>
                担责人：<span v-for="(lia,index) in taskData.liability" :key="index">{{ lia.name }},</span><br></span>
              <!-- 责任人:{{taskData.liability.length>0?taskData.liability[0].name:''}}</span> -->

              <span v-if="taskData.consultant.length>0">
              <i class="el-icon-user icons"/>顾问：{{ taskData.consultant.length>0?taskData.consultant[0].name:'' }}<br></span>

              <span v-if="taskData.participant.length>0">
              <!-- 参与人:{{taskData.participant.length>0?taskData.participant[0].name:''}}</span> -->
              <i class="el-icon-user icons"/>参与人：<span v-for="(lia,index) in taskData.participant" :key="index">{{ lia.name }},</span><br></span>
              <span v-if="taskData.notify.length>0">
              <i class="el-icon-user icons"/>知会人：<span v-for="(lia,index) in taskData.notify" :key="index">{{ lia.name }},</span></span>
              <!-- 知会人:{{taskData.notify.length>0?taskData.notify[0].name:''}}</span> -->

            </el-col>
          </el-row>
          <el-row class="drawer-item">
            <el-col :span="6">
              <span><i class="el-icon-tickets icons"/>任务描述：</span>
            </el-col>
            <el-col :span="18">
              <span v-for="item in taskData.task_desc" :key="item" style="display: block">{{ item }}</span>
            </el-col>
          </el-row>
          <el-row>

            <el-form
              ref="editForm"
              :model="editForm"
              :rules="rules"
              :inline="true"
              size="mini"
              label-width="100px"
              class="demo-editForm"
              :disabled="taskData.is_complete === 1"
              >
              <el-form-item label="是否已完成" >
                <el-radio-group v-model="editForm.is_complete">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-row>
                <el-col :span="12">
                  <el-form-item v-if="editForm.is_complete==1" label="完成时间" prop="complete_time">
                    <el-date-picker
                      v-model="editForm.complete_time"
                      :picker-options="startTime"
                      style="width: 180px;"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期" />
                  </el-form-item>
                  <el-form-item label="交付件类型" prop="deliver_type_id">
                    <el-select v-model="editForm.deliver_type_id" disabled placeholder="请选择">
                      <el-option v-for="item in deliverTypeList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="editForm.is_complete==1" label="交付件说明" prop="deliver_content">
                    <el-input :autosize="{ minRows: 2}" v-model="editForm.deliver_content" type="textarea"/>
                  </el-form-item>

                </el-col>

                <el-col :span="12">

                  <el-form-item v-if="editForm.is_complete==1" label="执行结果" prop="result_status" class="fdg">
                    <el-select v-model="editForm.result_status" placeholder="请选择">
                      <el-option :value="0" label="请选择" />
                      <el-option :value="1" label="非常差" />
                      <el-option :value="2" label="差" />
                      <el-option :value="3" label="一般" />
                      <el-option :value="4" label="好" />
                      <el-option :value="5" label="非常好" />
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="editForm.is_complete==1" label="差异分析" prop="difference" class="fdg">
                    <el-input v-model="editForm.difference" />
                  </el-form-item>
                  <el-form-item label="进度" prop="remark">
                    <el-input :autosize="{ minRows: 2}" v-model="editForm.remark" type="textarea" placeholder="请输入内容" />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="附件">
                <el-upload
                  :file-list="taskfileList"
                  :on-success="taskhandleChange"
                  :headers="{Authorization:token}"
                  :data="{upload_type:'attachment',file_type:'task',relate_id:editForm.id}"
                  class="upload-demo"
                  :action="action"
                  name="files"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <div v-for="(item,index) in editForm.attachments" :key="index" style="padding: 5px;">
                  <a :href="item.href" style="color: #409EFF;">{{ item.filename }}</a>
                  <span
              style="margin: 10px; font-size: 12px; color: red; cursor: pointer"
              @click="beforeRemove(item,index)"
              >删除</span
            >
                </div>
              </el-form-item>

            </el-form>
          </el-row>
          <div style="text-align: center;">
            <el-button v-if="taskData.is_complete !== 1" type="success" style="width: 150px;" @click="enterSubmit"> 更 新 </el-button>
          </div>
        </div>
        <div class="drawer-bottom">
          <el-divider> <span style="color: rgb(23, 41, 209);">任务进度</span> </el-divider>
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(activity, index) in logList"
              :key="index"
              :timestamp="activity.add_time"
              size="large"
              placement="top"
              color="#0bbd87">
              {{ activity.creator_name }}：{{ activity.content }}
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-drawer>
    <!-- 右侧弹框 -->

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { meetingtasks, getTaskbyId, getHistory, taskupdate, taskStatusCount, deleteFile } from '@/api/seedetails'
import { searchType } from '@/api/deliver'
export default {

  data() {
    return {
      token: '',
      drawer: false,
      searchForm: {
        time: '',
        meetTime: '',
        start_time: '',
        end_time: '',
        task_name: '',
        meeting_id: '',
        meeting_subject: '',
        task_tab: 'my', // 只查询关于我的任务，高管查询去掉我的
        workcode: this.$store.getters.username
      },
      editForm: {
        id: '',
        is_complete: '',
        deliver_type_id: '',
        deliver_content: '',
        result_status: '',
        difference: '',
        remark: '',
        complete_time: '',
        attachments: []
      },
      taskfileList: [],
      taskList: [],
      total: 0,
      page: 1,
      page_size: 20,
      activeName: 'all',
      taskData: {
        executor: [],
        liability: [],
        consultant: [],
        notify: [],
        participant: []
      },
      logList: [],
      deliverTypeList: [],
      rules: {

        deliver_type_id: [
          { required: true, message: '请选择交付件类型', trigger: 'change' }
        ],
        deliver_content: [
          { required: true, message: '请填写说明', trigger: 'blur' }
        ],
        result_status: [
          { required: true, message: '请选择结果', trigger: 'blur' }
        ],
        difference: [
          { required: true, message: '请填写分析', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请填写进度', trigger: 'blur' }
        ],
        complete_time: [
          { required: true, message: '请选择完成时间', trigger: 'change' }
        ]

      },
      startTime: {
        disabledDate: time => {
          const curDate = new Date()// 今天
          const preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000)// 昨天
          return time.getTime() <= preDate
        }
      },
      status_total: {
        all_num: 0,
        uncompleted: 0,
        complete: 0,
        overdue: 0
      },
      action: process.env.VUE_APP_BASE_API + '/common/upload'
    }
  },
  computed: {
    ...mapGetters(['roles', 'username'])
  },
  created() {
    this.activeName = 'all'
    this.page = 1
    this.getTaskList()
    this.getCount()
    this.getDeliverTypeList()
    this.token = this.$store.getters.token
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.page_size = val
      this.getTaskList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getTaskList()
    },
    // 分页
    searchFormSubmit() {
      this.page = 1
      this.getTaskList()
      this.getCount()
    },
    getTaskList() {
      const params = {
        page: this.page,
        page_size: this.page_size,
        task_tab: this.activeName,
        workcode: this.$store.getters.username,
        task_name: this.searchForm.task_name,
        meeting_subject: this.searchForm.meeting_subject,
        meeting_id: this.searchForm.meeting_id,
        start_time: this.searchForm.time ? this.searchForm.time[0] + ' 00:00:00' : '',
        end_time: this.searchForm.time ? this.searchForm.time[1] + ' 23:59:59' : '',
        estimate_start_time: this.searchForm.meetTime ? this.searchForm.meetTime[0] + ' 00:00:00' : '',
        estimate_end_time: this.searchForm.meetTime ? this.searchForm.meetTime[1] + ' 23:59:59' : ''
      }
      meetingtasks(params).then(res => { // meeting_id
        if (res.code === 'success' && res.data.status_total) {
          // this.status_total = res.data.status_total
        }
        if (res.data.tasks) {
          this.taskList = res.data.tasks
          this.total = res.data.pagination.total
        } else {
          this.taskList = []
          this.total = 0
        }
      })
    },
    // 获取数量统计
    getCount() {
      const params = {
        task_tab: this.activeName,
        workcode: this.$store.getters.username,
        task_name: this.searchForm.task_name,
        meeting_subject: this.searchForm.meeting_subject,
        meeting_id: this.searchForm.meeting_id,
        start_time: this.searchForm.time ? this.searchForm.time[0] + ' 00:00:00' : '',
        end_time: this.searchForm.time ? this.searchForm.time[1] + ' 23:59:59' : '',
        estimate_start_time: this.searchForm.meetTime ? this.searchForm.meetTime[0] + ' 00:00:00' : '',
        estimate_end_time: this.searchForm.meetTime ? this.searchForm.meetTime[1] + ' 23:59:59' : ''
      }
      taskStatusCount(params).then(response => {
        if (response.code === 'success' && response.data) {
          this.status_total = response.data
        }
      })
    },
    openBox(id) { // 获取任务信息，来编辑
      getTaskbyId(id).then(res => {
        if (res.data.task) {
          this.taskData = res.data.task
          this.taskData.task_desc = this.taskData.task_desc.split('\n')
          this.editForm.id = res.data.task.id
          this.editForm.is_complete = res.data.task.is_complete
          this.editForm.difference = res.data.task.difference
          this.editForm.complete_time = res.data.task.complete_time === '0000-00-00 00:00:00' ? '' : res.data.task.complete_time
          this.editForm.result_status = res.data.task.result_status
          this.editForm.deliver_type_id = res.data.task.deliver_type_id
          this.editForm.deliver_content = res.data.task.deliver_content,
          this.editForm.attachments = []
          this.taskfileList = []
          for (let index = 0; index < res.data.task.attachments.length; index++) {
            const element = res.data.task.attachments[index]
            this.editForm.attachments.push({
              id: element.id,
              filename: element.filename,
              href: `${process.env.VUE_APP_BASE_API}/common/download/` + element.id
            }
            )
          }
        } else {
          this.taskData = {}
        }
      }).catch(err => {
        console.log(err)
      })
      getHistory(id).then(res => {
        if (res.data.history.length > 0) {
          this.logList = res.data.history
          this.editForm.remark = res.data.history[0].content
        } else {
          this.logList = []
        }
      }).catch(err => {
        console.log(err)
      })
      this.drawer = true
    },
    handleClick(tab, event) { // 切换tab标签
      this.activeName = tab.name
      this.page = 1
      this.getTaskList()
      this.getCount()
    },
    enterSubmit() {
      this.$confirm('是否更新任务?', '提示', {
        confirmButtonText: '更新',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.editSubmit('editForm')
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    cancel() {
      this.drawer = false
    },
    // 提交编辑
    editSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) { // 提交  是否完成 参数不同
          let obj = {}
          if (this.editForm.is_complete === '0') {
            obj = {
              id: this.editForm.id,
              is_complete: this.editForm.is_complete,
              deliver_type_id: this.editForm.deliver_type_id,
              remark: this.editForm.remark,
              attachments: this.editForm.attachments
            }
          } else {
            obj = {
              id: this.editForm.id,
              is_complete: this.editForm.is_complete,
              deliver_type_id: this.editForm.deliver_type_id,
              remark: this.editForm.remark,
              deliver_content: this.editForm.deliver_content,
              result_status: this.editForm.result_status,
              difference: this.editForm.difference,
              complete_time: this.editForm.complete_time,
              attachments: this.editForm.attachments
            }
          }
          taskupdate(obj, obj.id).then(response => {
            if (response.code === 'success') {
              this.resetForm('editForm')
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.drawer = false
              this.searchFormSubmit()
            }
          }).catch(err => {
            console.log(err)
          })
          console.log(obj, 'canshu')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 获取交付件类型
    getDeliverTypeList() {
      const form = { page_size: 1000, page: 1 }
      searchType(form).then(response3 => {
        if (response3.code === 'success') {
          if (response3.data.types) {
            this.deliverTypeList = response3.data.types
          } else {
            this.deliverTypeList = []
          }
        } else {
          this.errMsg()
        }
      }).catch()
    },
    goMeeting(id) {
      this.$router.push({ name: 'seeDetails', query: { id: id }})
    },
    taskhandleChange(responses, file, fileList) {
      this.taskfileList = []
      this.editForm.attachments.push(
        {
          id: responses.data.attachment[0].id,
          filename: responses.data.attachment[0].filename,
          href: `${process.env.VUE_APP_BASE_API}/common/download/` + responses.data.attachment[0].id
        }
      )
    },
    beforeRemove(file, index) {
      this.$confirm('此操作将删除 ' + file.filename + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteFile(file.id).then((res) => {
            if (res.code === 'success') {
              this.editForm.attachments.splice(index, 1)
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>

<style scoped>
  .box-card{
    cursor: pointer;
  }
  .drawer-top {
    margin-bottom: 30px;
  }

  .drawer-item {
    line-height: 50px;
    height: 50px;
  }

  .drawer-item span {
    /*文字和icon  */
    font-size: 14px;
    color: rgb(143, 140, 140);
    margin: 5px;
  }

  .drawer-item i {
    /*文字和icon  */
    font-size: 16px;
    color: #ccc;
    font-weight: 600;
    padding:5px;
  }
  .el-form--inline .el-form-item {
    margin-right:0px;
  }
  .drawer-content{
    height: 100vh;
    padding: 50px 30px;
    overflow: auto;
  }
  .el-timeline{
    padding-left: 10px;
  }
</style>

<style lang="scss">
  .mytaskList {
    .amTask {
      font-size: 16px;
      margin-bottom: 15px;
      color: #3a3a3a;
    }

    .taskTip {
      color: #888;
      font-size: 14px;

      .time {
        margin-right: 5px;
      }

      span {
        margin-right: 10px;
      }
    }

    .el-tabs__item.is-active {
      font-weight: 800;
    }
  }
</style>
